import React from 'react';

let bubbleSortContent = {
                            'videos': {
                                'intuition': 'https://www.youtube.com/embed/VjAY6k6eYl0',
                                'analysis': 'https://www.youtube.com/embed/EDyWUwh5X7g',
                                'songAndCode': 'https://www.youtube.com/embed/sUK9xntV8io',
                             },
                        
                            'img': (
                                <img src={'./sortedListThick2.png'} style={{"width": "460px", "maxWidth": "100%"}} />
                            ),
                            'intuition': (
                                    <div style={{'paddingLeft':'10%','paddingRight':'10%',}}>
                                        <p>Bubble Sort takes in a list of values and sorts them from lowest to highest. It does this in two steps:</p>
                                        <ol>
                                            <li>loop through each position from left to right. Per position:<br />
                                                <span style={{'marginLeft': '40px',}}>if the value at the current one is greater than the next, swap the values.</span></li>
                                            <li>If at least one swap occurred during step 1, repeat the entire procedure, otherwise the list is sorted.</li>
                                        </ol>
                                    </div>
                            ),
                            'analysis': (
                                    <ul>
                                        <li>Learn the basics of big-O notation</li>
                                        <li>Determine why bubble sort uses <i>O(n<sup>2</sup>)</i> or quadratic time in the worst case</li>
                                        <li>Determine why bubble sort uses <i>O(1) </i>or constant extra memory in any case, i.e. it works in-place.</li>
                                        <li>Briefly discuss applications.</li>
                                    </ul>    
                            ),
                            'songAndCode': (
                                    <ul>
                                        <li>Hear the quick bubble sort song:
                                            <ol>
                                                <li>The first part covers big-O analysis facts and a general description of the algorithm.</li>
                                                <li>The second covers the pseudocode which will help you program bubble sort in any programming language.</li>
                                            </ol>
                                        </li>
                                        <li>Watch me demonstrate how to use the song lyrics to implement the algorithm in Python, the most straightforward programming language (in my opinion).</li>
                                    </ul>
                            )
                
};

export default bubbleSortContent;



// WEBPACK FOOTER //
// ./src/AlgoPageContent/bubble-sort/content.jsx